<template>
  <base-container ref="container">
    <ArtisanGrid ref="msgRecord" metaKey="JcMsgRecord" :metaInited="metaInited" @resend="resend">
    </ArtisanGrid>
  </base-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    metaInited(option){
      option.btns.push({
        code:"resend",
        name:"重发",
        icon:"el-icon-refresh",
        menuType:"rowBtn"
      })
    },
    resend(){
      this.$refs.container.alert({msg:"根据医院实际情况定制开发！"})
    }
  },
};
</script>

<style>
</style>